<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-items-center tw-justify-center">
            <h2>Obrigado!</h2>
            <p>Iremos entrar em contacto consigo<br>o mais rápido possível.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';

.form-success {
    background-color: transparent !important;
    width: 320px;
    height: 473px;
    @screen md {
        width: 450px;
        height: 585px;
    }

    h2 {
        margin-top: 200px;
        color: $main_color !important;
        text-align: center;
        font-weight: 700;
        font-size: 27px;
        line-height: 17px;
        @screen md {
            font-size: 40px;
            line-height: 35px;
        }
    }

    p {
        margin-top: 10px;
        color: $black !important;
        text-align: center;
        font-size: 14px;
        line-height: 17px;
        @screen md {
            font-size: 20px;
            line-height: 35px;
        }
    }
}

</style>
<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-items-center tw-justify-center">
            <h2>Obrigado!</h2>
            <p>Iremos entrar em contacto consigo<br>
                o mais rápido possível.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    width: 320px;
    height: 473px;
    background-color: #000;
    @screen md {
        width: 450px;
        height: 585px;
    }

    h2 {
        margin-top: 200px;
        color: #fff;
        text-align: center;
        font-weight: 700;
        font-size: 27px;
        line-height: 17px;
        @screen md {
            font-size: 40px;
            line-height: 35px;
        }
    }

    p {
        margin-top: 10px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        line-height: 17px;
        @screen md {
            font-size: 20px;
            line-height: 35px;
        }
    }
}

</style>
